import React from 'react';
import './styles/tokens.css';
import './styles/base.css';
import './Components/UI/ui.css';
import './App.css';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import * as serviceWorker from './serviceWorker';

import reducer from './Store/reducer';
import { initTheme } from './theme/theme';
import HomeComponent from './Components/User/Homepage/HomeComponent';
import GlobalRouteSeo from './Components/Generic/SEO/GlobalRouteSeo';
import PrerenderCrawlerLinks from './Components/Generic/SEO/PrerenderCrawlerLinks';
import { PageFallback, ScrollToTop, keyedByPath } from './Components/Layout/AppShell';
import loadable from './Components/Layout/loadable';

import axios from 'axios';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { getRoute, syncCityFromUrl } from './Service/endpoints';

// Route-level code splitting: only the homepage ships in the main bundle.
// (loadable() instead of React.lazy: this project pairs React 18 with ReactDOM 16.)
// Catalogue pages are prefetched in idle time because shoppers go there next.
const CategoryComponent = loadable(() => import(/* webpackChunkName: "catalog", webpackPrefetch: true */ './Components/User/Category/CategoryComponent'), PageFallback);
const SubCategoryComponent = loadable(() => import(/* webpackChunkName: "catalog-sub" */ './Components/User/SubCategory/SubCategoryComponent'), PageFallback);
const SearchComponent = loadable(() => import(/* webpackChunkName: "search" */ './Components/User/Search/SearchComponent'), PageFallback);
const ProductComponent = loadable(() => import(/* webpackChunkName: "product", webpackPrefetch: true */ './Components/User/Product/ProductComponent'), PageFallback);
const CartComponent = loadable(() => import(/* webpackChunkName: "cart" */ './Components/User/Cart/CartComponent'), PageFallback);
const AccountWrapper = loadable(() => import(/* webpackChunkName: "account" */ './Components/Account/AccountWrapper'), PageFallback);
const SettingsComponent = loadable(() => import(/* webpackChunkName: "account" */ './Components/User/Settings/SettingsComponent'), PageFallback);
const OrderConfirmationComponent = loadable(() => import(/* webpackChunkName: "order" */ './Components/User/Order/OrderConfirmationComponent'), PageFallback);
const InvoiceComponent = loadable(() => import(/* webpackChunkName: "invoice" */ './Components/Standalone/InvoiceComponent'), PageFallback);
const OrderSummaryComponent = loadable(() => import(/* webpackChunkName: "invoice" */ './Components/Standalone/OrderSummaryComponent'), PageFallback);
const AddNewAddress = loadable(() => import(/* webpackChunkName: "account" */ './Components/Standalone/AddNewAddress'), PageFallback);
const VRComponent = loadable(() => import(/* webpackChunkName: "vr" */ './Components/Standalone/VRComponent'), PageFallback);
const VRKitchen = loadable(() => import(/* webpackChunkName: "vr" */ './Components/Standalone/VRKitchen'), PageFallback);
const NewProductsHomepage = loadable(() => import(/* webpackChunkName: "partners" */ './Components/Generic/NewProductHomepage/NewProductsHomepage'), PageFallback);
const CustomizationComponent = loadable(() => import(/* webpackChunkName: "customization" */ './Components/User/Customization/CustomizationComponent'), PageFallback);
const LoginPageComponent = loadable(() => import(/* webpackChunkName: "login" */ './Components/User/GeneralLogin/LoginPage'), PageFallback);
const ResetPassword = loadable(() => import(/* webpackChunkName: "login" */ './Components/User/Login/Reset/ResetPassword'), PageFallback);
const AboutUsComponent = loadable(() => import(/* webpackChunkName: "info" */ './Components/User/InfoPages/AboutUS/AboutUsComponent'), PageFallback);
const FAQComponent = loadable(() => import(/* webpackChunkName: "info" */ './Components/User/InfoPages/FAQ/FAQComponent'), PageFallback);
const PrivacyPolicyComponenet = loadable(() => import(/* webpackChunkName: "info" */ './Components/User/InfoPages/PrivacyPolicy/PrivacyPolicyComponenet'), PageFallback);
const TermsAndConditionsComponent = loadable(() => import(/* webpackChunkName: "info" */ './Components/User/InfoPages/TermsAndConditions/TermsAndConditionsComponent'), PageFallback);
const Blog1Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog1Component'), PageFallback);
const Blog2Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog2Component'), PageFallback);
const Blog3Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog3Component'), PageFallback);
const Blog4Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog4Component'), PageFallback);
const Blog5Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog5Component'), PageFallback);
const Blog6Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog6Component'), PageFallback);
const Blog7Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog7Component'), PageFallback);
const Blog8Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog8Component'), PageFallback);
const Blog9Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog9Component'), PageFallback);
const Blog10Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog10Component'), PageFallback);
const Blog11Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog11Component'), PageFallback);
const Blog12Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog12Component'), PageFallback);
const Blog13Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog13Component'), PageFallback);
const Blog14Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog14Component'), PageFallback);
const Blog15Component = loadable(() => import(/* webpackChunkName: "blog" */ './Components/User/InfoPages/Blogs/Blog15Component'), PageFallback);

const Home = keyedByPath(HomeComponent);
const Category = keyedByPath(CategoryComponent);
const SubCategory = keyedByPath(SubCategoryComponent);
const Product = keyedByPath(ProductComponent);
const Search = keyedByPath(SearchComponent);

initTheme();
syncCityFromUrl();

const store = createStore(reducer);

let keycloak = {};

ReactGA.initialize('UA-125546749-1');


window.addEventListener('login', function (e) {

    keycloak = JSON.parse(localStorage.keycloak);
    axios.defaults.headers.common['Authorization'] = keycloak.token_type + " " + keycloak.access_token;

}, false);

if (typeof localStorage.keycloak != "undefined") {
    keycloak = JSON.parse(localStorage.keycloak);
    axios.defaults.headers.common['Authorization'] = keycloak.token_type + " " + keycloak.access_token;
}

const routing = (
    <Provider store={store}>
        <BrowserRouter>
            <ScrollToTop />
            <GlobalRouteSeo />
            <PrerenderCrawlerLinks />
            <Switch>
                <Route exact path="/indianrentals" component={NewProductsHomepage} />
                <Route exact path="/user/add/address" component={AddNewAddress} />
                <Route exact path="/vrBedroom" component={VRComponent} />
                <Route exact path="/vrKitchen" component={VRKitchen} />
                <Route exact path="/account" component={AccountWrapper} />
                <Route exact path="/account/invoices/:invoiceNumber" component={InvoiceComponent} />
                <Route exact path="/account/order/:orderNumber" component={OrderSummaryComponent} />
                <Route exact path="/cart" component={CartComponent} />
                <Route exact path="/settings" component={SettingsComponent} />
                <Route exact path="/order/:status" component={OrderConfirmationComponent} />
                <Route exact path="/about-us" component={AboutUsComponent} />
                <Route exact path="/faq" component={FAQComponent} />
                <Route exact path="/customization" component={CustomizationComponent} />
                <Route exact path="/privacy-policy" component={PrivacyPolicyComponenet} />
                <Route exact path="/blogs/buying-vs-renting" component={Blog1Component} />
                <Route exact path="/blogs/beginners-guide" component={Blog2Component} />
                <Route exact path="/blogs/tips-for-renting-furniture" component={Blog3Component} />
                <Route exact path="/blogs/furniture-rentals" component={Blog4Component} />
                <Route exact path="/blogs/aesthetic-ideas" component={Blog5Component} />
                <Route exact path="/blogs/upgrade-lifestyle" component={Blog6Component} />
                <Route exact path="/blogs/seasonal-selfcare" component={Blog7Component} />
                <Route exact path="/blogs/types-of-wood" component={Blog8Component} />
                <Route exact path="/blogs/best-furniture-on-rent-in-gurgaon" component={Blog9Component} />
                <Route exact path="/blogs/sofa-on-rent-in-gurgaon" component={Blog10Component} />
                <Route exact path="/blogs/rented-appliances-in-gurgaon" component={Blog11Component} />
                <Route exact path="/blogs/get-a-bed-on-rent-in-gurgaon" component={Blog12Component} />
                <Route exact path="/blogs/get-a-fridge-on-rent-in-gurgaon" component={Blog13Component} />
                <Route exact path="/blogs/study-table-on-rent-in-gurgaon" component={Blog14Component} />
                <Route exact path="/blogs/rent-a-chair-in-gurgaon" component={Blog15Component} />
                <Route exact path="/terms-conditions" component={TermsAndConditionsComponent} />
                <Route exact path="/password/reset/:username/:token" component={ResetPassword} />
                <Route exact path="/search/:query" component={Search} />
                <Route exact path="/login" component={LoginPageComponent} />
                <Route exact path="/" component={Home} />
                {/* City-less category URLs (e.g. from llms.txt or old links) go to the visitor's city. */}
                <Route exact path="/furniture" render={() => <Redirect to={getRoute('furniture')} />} />
                <Route exact path={["/appliances", "/appliance"]} render={() => <Redirect to={getRoute('appliances')} />} />
                <Route exact path="/:city" component={Home} />
                <Route exact path="/thankyou" component={Home} />
                <Route exact path="/:city/:category" component={Category} />
                <Route exact path="/:city/:category/:subCategory" component={SubCategory} />
                <Route exact path="/:city/:category/:subCategory/:productSlug" component={Product} />
            </Switch>
        </BrowserRouter>
    </Provider>
);


ReactDOM.render(routing, document.getElementById('root'));
serviceWorker.unregister();
